import { useCookies } from "react-cookie"
import { useEffect } from "react"
import "./PrefsModal.css"
import Checkbox from "../Input/Checkbox"

function PrefsModal({ closeHandler, userPrefs, setUserPrefs }) {
    return (
        <div className="prefs-modal">
            <i
                className="fas fa-times fa-2x close-new-form prefs-modal-close"
                onClick={closeHandler}
            ></i>
            <h1>Schimbă preferințele pentru pagină</h1>
            <div className="prefs-options">
                <Checkbox 
                    name="use-old-list"
                    description="Vezi lista consultațiilor în formatul original"
                    initialState={userPrefs.useOldList}
                    onChange={() => setUserPrefs({ ...userPrefs, useOldList: !userPrefs.useOldList })}
                />

                <Checkbox
                    name="use-old-form"
                    description="Folosește formularul vechi"
                    initialState={userPrefs.useOldForm}
                    onChange={() => setUserPrefs({ ...userPrefs, useOldForm: !userPrefs.useOldForm })}
                />

                <Checkbox
                    name="see-upcoming-only"
                    description="Ascunde consultațiile din trecut"
                    initialState={userPrefs.seeUpcomingOnly}
                    onChange={() => setUserPrefs({ ...userPrefs, seeUpcomingOnly: !userPrefs.seeUpcomingOnly })}
                />
            </div>
        </div>
    )
}

export default PrefsModal